export const BREAKDOWN_CUSTOM = 'custom';
export const BREAKDOWN_PHASES = 'phases';
export const BREAKDOWN_WEEKLY = 'weekly';
export const BREAKDOWN_MONTHLY = 'monthly';
export const ALLOCATIONS_GET_FILTERED_ROLE_AVAILABILITIES_BEGIN = 'ALLOCATIONS_GET_FILTERED_ROLE_AVAILABILITIES_BEGIN';
export const ALLOCATIONS_GET_FILTERED_ROLE_AVAILABILITIES_SUCCESS = 'ALLOCATIONS_GET_FILTERED_ROLE_AVAILABILITIES_SUCCESS';
export const ALLOCATIONS_GET_FILTERED_ROLE_AVAILABILITIES_FAILURE = 'ALLOCATIONS_GET_FILTERED_ROLE_AVAILABILITIES_FAILURE';
export const ALLOCATIONS_GET_FILTERED_ROLE_AVAILABILITIES_DISMISS_ERROR = 'ALLOCATIONS_GET_FILTERED_ROLE_AVAILABILITIES_DISMISS_ERROR';
export const ALLOCATIONS_SET_RADIUS = 'ALLOCATIONS_SET_RADIUS';
